import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "../layouts/Layout";
import { SerialNumber } from "../componen/SerialNumber";

export const SerialNumberPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate("/", { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
      <SerialNumber />
    </Layout>
  );
};
